import { useCallback, useEffect, useState } from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import { api } from "@/lib/api";
import MenuView from "@/components/menu/MenuView";
import Landing from "@/components/menu/Landing";
import { MenuError, MenuSkeleton } from "@/components/menu/MenuStates";

export default function PublicSite() {
  const [state, setState] = useState({ data: null, error: false });
  const load = useCallback(() => {
    setState({ data: null, error: false });
    api.get("/public/menu")
      .then((r) => setState({ data: r.data, error: false }))
      .catch(() => setState({ data: null, error: true }));
  }, []);
  useEffect(() => {
    load();
  }, [load]);

  if (state.error) return <MenuError onRetry={load} />;
  if (!state.data) return <MenuSkeleton />;
  return <Outlet context={{ data: state.data, mode: "public", base: "" }} />;
}

export function LandingRoute() {
  const { data, mode } = useOutletContext();
  if (!data.menus?.length) return <MenuView data={data} mode={mode} />;
  return <Landing />;
}
